import { useQuery } from '@tanstack/react-query';
import { makeDomainQueryOptions } from '#api/domains.queries.ts';
import { makeEndpointOIDCProviderQueryOptions } from '#api/endpoint-oidc-providers.queries.ts';
import { useBrowserStorage } from '#hooks/useBrowserStorage.ts';

export function useShowEnableBannerForProvider() {
  const [providerId, setProviderId, clearProviderId] = useBrowserStorage<string>('enable-banner', 'local');
  const id = typeof providerId === 'string' ? providerId : null;
  const { data: { data: provider } = {} } = useQuery({
    ...makeEndpointOIDCProviderQueryOptions(id ?? ''),
    enabled: Boolean(id),
  });
  const { data: { data: domain } = {} } = useQuery({
    ...makeDomainQueryOptions(provider?.domainID ?? ''),
    enabled: Boolean(provider?.domainID),
  });

  return {
    providerId: id,
    provider,
    domain,
    setProviderId,
    clearProviderId,
  };
}

/** The admin provider to prompt for enabling once its domain is verified; AdminOIDCList shows the prompt */
export function useAdminEnableBannerProviderId() {
  return useBrowserStorage<string>('admin-enable-banner', 'local');
}
